import styled from 'styled-components'

export const officeHeaderHeight = 34
export const OfficeSectionHeader = styled.div`
  height: ${officeHeaderHeight}px;
  position: absolute;
  right: 10px;
  left: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 5px;
  box-sizing: border-box;
`

export const OfficeSectionBody = styled.div`
  position: absolute;
  top: ${p => (p.top === undefined ? officeHeaderHeight : p.top)}px;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  overflow: hidden;
`
